import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=40168774&scoped=true&lang=html"
import script from "./bannerList.vue?vue&type=script&lang=js"
export * from "./bannerList.vue?vue&type=script&lang=js"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=40168774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40168774",
  null
  
)

export default component.exports